import React from 'react';

import ExploreNewsfeedImage from '../../../assets/mock/Rewire-ZEOS-Explore.png';
import { DashboardFooter } from '../layout/DashboardFooter';
import { DashboardHeader } from '../layout/DashboardHeader';

export const ExploreScreen = () => {
  return (
    <div className="w-full h-full">
      <DashboardHeader />
      <img
        src={ExploreNewsfeedImage}
        alt="Explore Placeholder"
        className="w-full h-auto"
      />
      <DashboardFooter />
    </div>
  );
};
